import { RoundPlusIcon, RoundMinusIcon } from '@/components/icons'
import { Checkbox } from '@/components/ui/checkbox'

export const IncludeButton = ({ included, handleChange }) => {
    if (included) {
        return (
            <button
                onClick={handleChange}
                className="tw:hover:!bg-transparent tw:hover:!text-green-300/70 tw:text-green-300"
            >
                <RoundPlusIcon className="" />
            </button>
        )
    }

    return (
        <div className="tw:h-6 tw:w-6 tw:flex tw:items-center tw:justify-center">
            <Checkbox
                checked={false}
                onCheckedChange={handleChange}
                className="tw:!rounded-full tw:!border-blue-300 tw:!bg-blue-300/10"
            />
        </div>
    )
}

export const ExcludeButton = ({ excluded, handleChange }) => {
    if (excluded) {
        return (
            <button
                onClick={handleChange}
                className="tw:hover:!bg-transparent tw:hover:!text-red-300/70 tw:text-red-300"
            >
                <RoundMinusIcon className="" />
            </button>
        )
    }

    return (
        <div className="tw:h-6 tw:w-6 tw:flex tw:items-center tw:justify-center">
            <Checkbox
                checked={false}
                onCheckedChange={handleChange}
                className="tw:!rounded-full tw:!border-blue-300 tw:!bg-blue-300/10"
            />
        </div>
    )
}
